
import WatchStatus from "../../../assets/filled/WatchStatus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WatchStatusIcon({ className, dataTestid = "WatchStatusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <WatchStatus data-testid={dataTestid} className={classes} {...rest} />
  );
}
